module.exports = __webpack_public_path__ + "img/a9ef066.svg";